// extracted by mini-css-extract-plugin
export default {"actions":"ContactsActions_actions__aBuXE","actionsButton":"ContactsActions_actionsButton__9rQgx"};